<template>
  <div class="product-bar">
    <slider
      :number-of-children="products.length"
      hide-nav
      :gap="15"
      :width="150"
      :loading-style="{ height: '200px' }"
      with-scroll-bar
    >
      <nuxt-link
        v-for="productDocument in products"
        :key="`product-${productDocument._id}`"
        :to="$contextSanityPath(productDocument)"
        :title="productDocument.title"
        class="p-relative slider__element"
        @click.native="trackProductClick(productDocument)"
      >
        <div class="product-bar__image">
          <lazy-image
            :image="getImage(productDocument)"
            :widths="[150, 300]"
            sizes="150px"
            provider="sanity"
          />
        </div>
        <p
          class="product-name text-uppercase text-color-secondary text-small text-md-base text-secondary mb-0 mt-0-4"
          :class="{
            'product-name--long': productDocument.title.length >= 30,
          }"
        >
          {{ productDocument.title }}
        </p>
      </nuxt-link>
    </slider>
  </div>
</template>

<script>
import LazyImage from '@/components/Image/LazyImage'
import Slider from '@/components/slider/Slider'

import { getSanityBunnyImageLink } from '@/utils/image'
import { PRODUCT_IMAGE_FORMAT } from '~/const/image'

export default {
  name: 'ProductBar',
  components: {
    LazyImage,
    Slider,
  },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getImage(productDocument) {
      if (productDocument && productDocument.image?.image) {
        return {
          url: getSanityBunnyImageLink(
            productDocument.image_product_bar
              ? productDocument.image_product_bar
              : productDocument.image?.image,
            PRODUCT_IMAGE_FORMAT.PRODUCT_BAR
          ),
          dimensions: PRODUCT_IMAGE_FORMAT.PRODUCT_BAR,
        }
      }

      return null
    },
    trackProductClick(productDocument) {
      this.$track.event('product-bar-click', {
        uid: productDocument.uid,
      })
    },
  },
}
</script>

<style lang="scss">
.product-bar {
  overflow: hidden;
  max-width: 100%;

  .slider__element {
    width: rem(150px);
    overflow: hidden;
  }

  .slider--scroll-bar .inner {
    padding: 0 var(--spacing) var(--spacing);
  }

  &__image {
    position: relative;

    @include on-hover-and-focus {
      &::after {
        opacity: 0;
      }

      .lazy-image {
        transform: scale(1.1);
      }
    }
  }

  .product-name {
    font-size: rem(18px);
    transition: all 0.3s;
    letter-spacing: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.product-bar__loading {
  display: grid;
  gap: rem(15px);
  grid-template-columns: repeat(9, 150px);
  justify-content: center;
}
</style>
